import { useIntervalFn } from '@vueuse/core';
import { storeToRefs } from 'pinia';
import { ref } from 'vue';
import type { IPopularMixParlay } from '@/interface/IPopularMixParlay';
import { RecommendType } from '@/interface/enum';
import { RecommendationApi } from '@/libraries/recommendation/recommendationApi';
import { useRootStore } from '@/stores/rootStore';

const pollIntervalMs = 30_000;
const combinationCount = 3;

export function useMpRecommendations() {
    const { sportType } = storeToRefs(useRootStore());

    const popularMixParlays = ref<IPopularMixParlay[]>([]);
    const isLoaded = ref(false);

    async function fetchMpRecommendations() {
        try {
            const response = await RecommendationApi.getMpRecommendations(
                sportType.value,
                RecommendType.BetCount,
                combinationCount,
            );
            popularMixParlays.value = response;
        } catch (error) {
            console.error('Failed to fetch mp recommendations', error);
        } finally {
            isLoaded.value = true;
        }
    }

    useIntervalFn(fetchMpRecommendations, pollIntervalMs);

    fetchMpRecommendations();

    return {
        popularMixParlays,
        isLoaded,
    };
}
